export default {
  enumerations: {
    prop: {
      name: '名称',
      code: '编号',
      icon: '图标',
      car_model: '型号'
    },
    type: {
      charger_brand: '充电桩品牌',
      car_brand: '汽车品牌',
      charger_type: '充电桩类型',
      plug_type: '枪口类型',
      charge_rate: '充电速率',
      car_type: '汽车型号',
      ChargerBrand: '充电桩品牌',
      CarBrand: '汽车品牌',
      ChargerType: '充电桩类型',
      PlugType: '枪口类型',
      ChargeRate: '充电速率'
    },

    index: {
      title: '电桩基本设置',
      charger_brand_tab: '充电桩品牌',
      car_brand_tab: '汽车品牌',
      charger_type_tab: '充电桩类型',
      plug_type_tab: '枪口类型',
      charge_rate_tab: '充电速率',
      add: '添加',
      create: '创建{0}'
    },
    car_brand: {
      new_car_type: '新增汽车型号',
      manage_car_type: '管理汽车型号'
    }
  }
}
